import { useTranslation } from 'react-i18next';

export const useGetWhatIsItFor = () => {
    const { t } = useTranslation();
    return [
        {
            step: t('welcomeAnim.whatIsItFor.weddings'),
        },
        {
            step: t('welcomeAnim.whatIsItFor.beachClubs'),
        },
        {
            step: t('welcomeAnim.whatIsItFor.corporateEvents'),
        },
        {
            step: t('welcomeAnim.whatIsItFor.privateParties'),
        },
        {
            step: t('welcomeAnim.whatIsItFor.exhibitions'),
        },
        {
            step: t('welcomeAnim.whatIsItFor.resorts'),
        },
    ];
};
